import React from 'react';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { AiOutlineInstagram } from 'react-icons/ai';

export const socialNetData = [
  {
    name: 'instagram',
    link: 'https://www.instagram.com/kyriakos.94/',
    icon: <AiOutlineInstagram className="contact-social--icon contact-social--icon_ig" />,
  },
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/in/popovicnedeljko994/',
    icon: <BsLinkedin className="contact-social--icon contact-social--icon_ln" />,
  },
  {
    name: 'GitHub',
    link: 'https://github.com/popovic-nedeljko',
    icon: <BsGithub className="contact-social--icon contact-social--icon_git" />,
  },
];
